import omit from 'lodash/omit';

export default (state, action) => {
  const { estimateCount, containerCount, itemCount } = state;
  const { estimateId, containerIds, nextEstimate } = action.payload;

  const updatedContainerCount = omit(containerCount, estimateId);
  let updatedItemCount = { ...itemCount };

  containerIds.forEach((givenId) => {
    updatedItemCount = omit(updatedItemCount, givenId);
  });

  return {
    ...state,
    selectedEstimate: nextEstimate,
    estimateCount: estimateCount - 1,
    containerCount: updatedContainerCount,
    itemCount: updatedItemCount,
  };
};
